module.exports = __webpack_public_path__ + "static/img/bg_world map@2x.efc6e95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_world map@2x.png
// module id = 9/Bz
// module chunks = 0